'use client'

import Link from 'next/link'
import { clsx } from 'shared/libs/style-merge'

import { Category } from 'modules/Category/model/types'

import { ROUTER_PATHS } from 'shared/config/routerPath/RouterPath'

import { SubCategoryList } from '../../SubCategoryList/Desktop'

import styles from './CategoryItem.module.scss'

interface CategoryItemProps {
  id: Category['id']
  slug: Category['slug']
  name: Category['name']
  is_disable: Category['is_disable']
  children?: Category['children']
}

export function CategoryItem({
  id,
  name,
  slug,
  is_disable,
  children = [],
}: CategoryItemProps) {
  return (
    <div className={styles.categoryItem} key={id}>
      {!children.length && !is_disable ? (
        <Link
          className={styles.listTitleLink}
          href={ROUTER_PATHS.catalogCategoryById.get(slug)}
        >
          {name}
        </Link>
      ) : (
        <h4
          className={clsx(styles.listTitle, { [styles.disabled]: is_disable })}
        >
          {name}
        </h4>
      )}
      {children.length > 0 && <SubCategoryList>{children}</SubCategoryList>}
    </div>
  )
}
